module.exports = __webpack_public_path__ + "img/search.990bcec0.png";